import {takeLatest} from 'redux-saga/effects';
import {
  CompositionsTypes,
  fetchCompositionById,
  fetchCompositionJsonStatsAsync,
  writeComposition,
} from '../reducers/compositions';

const compositionSagas = [
  takeLatest(CompositionsTypes.FETCH_BY_ID_REQUEST, fetchCompositionById),
  takeLatest(
    CompositionsTypes.FETCH_COMPOSITION_JSON_STATS_ASYNC_REQUEST,
    fetchCompositionJsonStatsAsync,
  ),
  takeLatest(CompositionsTypes.WRITE_COMPOSITION_REQUEST, writeComposition),
];

export default compositionSagas;
